import React from "react";

export default function PageHeader({ title, subtitle }) {
  return (
    <section className="bg-gradient-to-br from-aquiraaNavy to-aquiraaBlue text-white py-16 px-6 text-center">
      <h1 className="text-3xl md:text-5xl font-bold mb-3">{title}</h1>
      {subtitle && (
        <p className="text-base md:text-lg max-w-2xl mx-auto opacity-90">
          {subtitle}
        </p>
      )}
    </section>
  );
}
